import { useSelector } from "react-redux";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_PERMISSIONS = {
  view: false,
  add: false,
  edit: false,
  delete: false,
};

const ALL_PERMISSIONS = {
  view: true,
  add: true,
  edit: true,
  delete: true,
};

export const usePermission = () => {
  const { pathname } = useLocation(); // "/discount"
  const userData = useSelector((state) => state.counter?.userData);

  const permissions = useMemo(() => {
    if (!userData) return DEFAULT_PERMISSIONS;

    // ✅ SUPER ADMIN
    if (userData?.isSuperAdmin === true || userData?.menus === "ALL") {
      return ALL_PERMISSIONS;
    }

    if (!Array.isArray(userData.menus)) {
      return DEFAULT_PERMISSIONS;
    }

    // ✅ FIX: Handle null/undefined paths
    const normalize = (path) => {
      if (!path || path === null || path === undefined) return "";
      return path.replace(/^\//, "").toLowerCase();
    };

    const currentRoute = normalize(pathname);

    const menu = userData.menus.find((m) => {
      // ✅ Skip menus without routes
      if (!m.route || m.route === null) return false;
      return normalize(m.route) === currentRoute;
    });

    if (!menu || !menu.permissions) {
      return DEFAULT_PERMISSIONS;
    }

    return {
      view: !!menu.permissions.view,
      add: !!menu.permissions.add,
      edit: !!menu.permissions.edit,
      delete: !!menu.permissions.delete,
    };
  }, [userData, pathname]);

  return permissions;
};